export enum EventsName {
  MODAL_RICH_TEXT = 'MODAL_RICH_TEXT',
  MODAL_RICH_TEXT_LEAVE = 'MODAL_RICH_TEXT_LEAVE',
  MODAL_RICH_TEXT_FULL_SCREEN = 'MODAL_RICH_FULL_SCREEN'
}
